module.exports = __webpack_public_path__ + "img/state_map_white.5132f1a3.svg";